import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 10C0 4.477 4.477 0 10 0h28c5.523 0 10 4.477 10 10v28c0 5.523-4.477 10-10 10H10C4.477 48 0 43.523 0 38z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0068FF",
  d: "m34.35 15.76-9.323-3.885a2.8 2.8 0 0 0-.895-.18 2.8 2.8 0 0 0-.896.18l-9.322 3.884c-.87.36-1.437 1.209-1.437 2.107 0 12.532 9.186 18.688 11.647 18.688 2.486 0 11.658-6.224 11.658-18.688 0-.898-.568-1.748-1.432-2.107m-4.278 5.262a.77.77 0 0 1-.227.55l-6.716 6.757a.775.775 0 0 1-1.097 0l-3.613-3.607a.8.8 0 0 1-.228-.593c0-.198.076-.397.228-.549l.549-.549a.87.87 0 0 1 .549-.183c.238 0 .398.072.553.223l2.511 2.511 5.618-5.617a.775.775 0 0 1 1.098 0l.55.549a.76.76 0 0 1 .225.508"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }